@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.description {
  display: flex;
  align-items: center;
  gap: 3px;
  flex: 1 0 0;
  svg {
    flex-shrink: 0;
  }
}

.buttonsContainer {
  display: flex;
  align-items: center;
  gap: 5px;
}
